module.exports = __webpack_public_path__ + "img/pencil-square-active.c1261021.svg";